import { render, staticRenderFns } from "./frPrivacy.vue?vue&type=template&id=45ec439a&scoped=true&"
import script from "./frPrivacy.vue?vue&type=script&lang=js&"
export * from "./frPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./frPrivacy.vue?vue&type=style&index=0&id=45ec439a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec439a",
  null
  
)

export default component.exports